import React, { useEffect, useRef, useState, useContext } from "react";
import { Typography } from "@material-ui/core";
import {
  mdiBookmark,
  mdiBookmarkOutline,
  mdiCircleSmall,
  mdiCircle,
  mdiDotsHorizontal,
  mdiMenu,
  mdiPlus,
  mdiEye,
  mdiAccountMultiplePlusOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { detailProject } from "actions/project/detailProject";
import { detailStatus } from "actions/project/setting/detailStatus";
import { updatePinBoardSetting } from "actions/project/setting/updatePinBoardSetting";
import { chooseTask } from "actions/taskDetail/taskDetailActions";
import Avatar from "components/CustomAvatar";
import { get, isNil } from "lodash";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import { statusSelector } from "views/ProjectGroupPage/Modals/ProjectSetting/selectors";
import SearchButton from "views/ProjectGroupPage/RightPart/AllProjectTable/components/SearchButton";
import DrawerFilter from "./components/DrawerFilter";
import MenuCreateNew from "views/JobDetailPage/ListPart/ListHeader/MenuCreateNew";
import { CustomLayoutContext } from "components/CustomLayout";
import CreateNewGroupTask from "views/ProjectPage/Modals/CreateNewGroupTask";
import CreateJobModal from "views/JobDetailPage/ListPart/ListHeader/CreateJobModal";
import RequestPermission from "./components/RequestPermission";
import MemberSetting from "views/ProjectPage/Modals/MembersSetting";
import IconPickerPopover from "components/IconPickerPopover";
import ReactDOMServer from "react-dom/server";
import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { useStyles } from "./styles";
import CusTooltip from "components/CustomTooltip";

const HeaderProject = ({
  view = "list",
  project,
  status,
  valueSearch,
  expand,
  onSearch = () => {},
  onExpand = () => {},
  onOpenCreateModal = () => {},
  onUpdatePinBoardSetting = () => {},
  onAddColumns = () => {},
  onHideColumn = () => {},
  setItemLocation = () => {},
  onReOrderColumns = () => {},
  onChangeSummaryRowStatus = () => {},
  doDetailStatus,
  onExportData = () => {},
  canUpdateProject = true,
  ...props
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation();
  const refFilter = useRef(null);
  const refID = useRef();

  const { selectedGroup } = useContext(CustomLayoutContext);

  const [isPinned, setIsPinned] = useState(false);
  const [defaultView, setDefaultView] = useState(null);
  const [openCreateTaskGroup, setOpenCreateTaskGroup] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openRequestPermission, setOpenRequestPermission] = useState(false);
  const [openMemberSetting, setOpenMemberSetting] = useState(false);
  const [iconProject, setIconProject] = useState(get(project, "icon_url", ""));
  const detailStatus = useSelector(
    ({ project }) => project?.setting?.detailStatus
  );

  const refIsFirstTime = useRef(true);
  const { pathname } = useLocation();
  const history = useHistory();
  const projectId = pathname.split("/")[3];
  const percentComplete = get(project, "complete", 0);

  useEffect(() => {
    if (detailStatus?.data) {
      setDefaultView(detailStatus?.data?.status?.view);
    }
  }, [detailStatus]);

  const NAV_BARS_LIST = [
    {
      id: 4,
      title: t("VIEW_OFFER_LABEL_OVERVIEW_TITLE"),
      to: `/projects/dashboard/${projectId}`,
    },
    {
      id: 0,
      title: "List",
      to: `/projects/task-table/${projectId}`,
    },
    {
      id: 3,
      title: "Kanban",
      to: `/projects/task-kanban/${projectId}`,
    },
    {
      id: 2,
      title: "Gantt",
      to: `/projects/task-gantt/${projectId}`,
    },
    {
      id: 1,
      title: "Chat",
      to: `/projects/task-chat/${projectId}?task_id=${project?.main_task}`,
    },
    {
      id: 5,
      title: t("IDS_WP_REPORT"),
      to: `/projects/report/${projectId}`,
    },
  ];

  useEffect(() => {
    if (projectId && projectId !== refID.current) {
      dispatch(detailProject({ projectId }, true));
      refID.current = projectId;
    }
  }, [dispatch, projectId]);

  useEffect(() => {
    if (project && !isNil(get(project, "id"))) {
      doDetailStatus({
        projectId: get(project, "id"),
      });
      setIconProject(get(project, "icon_url", ""));
    }
  }, [project, doDetailStatus]);

  useEffect(() => {
    if (status?.status && refIsFirstTime.current) {
      setIsPinned(status?.status?.is_pin_on_personal_board || false);
      refIsFirstTime.current = false;
    }
  }, [status]);

  const _toggleDrawerMenu = () => {
    refFilter.current._toggle();
  };

  const _handleUpdatePinBoard = () => {
    setIsPinned(!isPinned);
    onUpdatePinBoardSetting({
      projectId: get(project, "id"),
      status: isPinned,
    });
  };

  const handleOpenMenuCreate = (e) => {
    setOpenMenu(e.target);
  };

  const MenuOutlinedIconCus = () => (
    <MenuOutlinedIcon
      sx={{
        width: "1.3em",
        height: "1.3em",
      }}
      style={{ color: "#787878" }}
    />
  );

  const StyledMenuOutlinedIcon = styled(MenuOutlinedIconCus)`
    padding: 3px;
    cursor: pointer;
    color: #787878;
    border-radius: 3px;
  `;

  const _renderIconExpand = (event) => {
    return <StyledMenuOutlinedIcon onClick={() => onExpand(!expand)} />;
  };

  return (
    <div id="project-topbar" className={classes.topbar}>
      <Box
        id="menu_expand_icon"
        sx={{
          "&:hover": {
            background: "#EBEDF0",
          },
        }}
        style={{
          transform: `${expand ? "scale(-1, -1)" : "scale(1, 1)"}`,
          marginRight: 10,
          padding: 5,
          borderRadius: 7,
        }}
        onClick={() => onExpand(!expand)}
        onMouseEnter={(e) =>
          (e.currentTarget.firstElementChild.innerHTML =
            ReactDOMServer.renderToString(
              <MenuOpenOutlinedIcon sx={{ fontSize: 28, color: "#787878" }} />
            ))
        }
        onMouseLeave={(e) =>
          (e.currentTarget.firstElementChild.innerHTML =
            ReactDOMServer.renderToString(
              <MenuOutlinedIcon sx={{ fontSize: 28, color: "#787878" }} />
            ))
        }
      >
        {_renderIconExpand()}
      </Box>
      <div className={classes.header}>
        <div className={classes.logo}>
          <IconPickerPopover
            iconProject={iconProject}
            setIconProject={setIconProject}
            projectId={projectId}
            project={project}
            gantt={history.location.pathname.includes("gantt")}
          >
            <Avatar
              alt="Logo"
              src={iconProject}
              style={{
                width: history.location.pathname.includes("gantt") ? 40 : 28,
                height: history.location.pathname.includes("gantt") ? 40 : 28,
                background: project?.group_project_color ?? "rgb(0, 120, 243)", // thay bằng màu group
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "10px",
                cursor: "pointer",
                padding: "6px",
                marginTop: "8px",
              }}
              styleImg={{
                borderRadius: "unset",
              }}
            />
          </IconPickerPopover>
        </div>
        <div className={classes.titleAndNav}>
          <div className={classes.titleRow}>
            <div className={classes.leftWrapper}>
              <Link to={`/projects/dashboard/${projectId}`}>
                {get(project, "name", "")}
              </Link>
              <Box
                onClick={_handleUpdatePinBoard}
                sx={{ width: "20px", cursor: "pointer" }}
              >
                {isPinned ? (
                  <StarRoundedIcon
                    onClick={_handleUpdatePinBoard}
                    sx={{ "&:hover": { fill: "#FF9800" }, fill: "#FF9800" }}
                  />
                ) : (
                  <StarOutlineRoundedIcon
                    onClick={_handleUpdatePinBoard}
                    sx={{ "&:hover": { fill: "#FF9800" } }}
                  />
                )}
              </Box>
              {/* <Icon
                className={classes.iconHeader}
                path={isPinned ? mdiBookmark : mdiBookmarkOutline}
                size={1}
                onClick={_handleUpdatePinBoard}
              /> */}

              <div className={classes.progressTitle}>
                <Icon path={mdiCircleSmall} size={2} color="#009143" />
                <span style={{ marginLeft: -10 }}>
                  {t("PROJECT_PAGE.PROGRESSING")} ({percentComplete}%)
                </span>
              </div>

              {!canUpdateProject && (
                <Button
                  variant="container"
                  className={classes.btnWatchOnly}
                  endIcon={<ArrowDropDownIcon />}
                  onClick={(event) => setOpenRequestPermission(event.target)}
                >
                  <Icon path={mdiEye} size={0.8} marginRight={4} />
                  {t("REQUEST_PROJECT.VIEW_ONLY")}
                </Button>
              )}
            </div>

            <div className={classes.rightWrapper}>
              <SearchButton valueSearch={valueSearch} onSearch={onSearch} />
              {canUpdateProject && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.btnShare}
                  onClick={() => setOpenMemberSetting(true)}
                >
                  <Icon
                    path={mdiAccountMultiplePlusOutline}
                    size={1}
                    marginRight={4}
                  />
                  {t("IDS_WP_SHARE")}
                </Button>
              )}
              <div
                className={classes.wrapperButton}
                onClick={_toggleDrawerMenu}
              >
                <Icon path={mdiDotsHorizontal} size={1} />
                <span style={{ marginLeft: 5 }}>{t("OPEN_MENU")}</span>
              </div>
              {/* {canUpdateProject && (
                <div
                  className={classes.wrapperButton}
                  onClick={(e) => handleOpenMenuCreate(e)}
                >
                  <Icon path={mdiPlus} size={1} />
                  <span style={{ marginLeft: 5 }}>
                    {t("IDS_WP_CREATE_NEW")}
                  </span>
                </div>
              )} */}
            </div>
          </div>
          <div className={classes.navMenuRow}>
            <div className={classes.navBar}>
              <nav className={classes.tabNavBar}>
                <ul>
                  {NAV_BARS_LIST.map((item) => (
                    <ItemNav
                      key={item.id}
                      defaultView={defaultView}
                      {...item}
                      mainTask={project?.main_task}
                    />
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <DrawerFilter
        ref={refFilter}
        view={view}
        project={project}
        isProjectVisible={get(project, "visibility")}
        isShareProject={get(project, "is_shared")}
        valueSearch={valueSearch}
        onSearch={onSearch}
        onReOrderColumns={onReOrderColumns}
        onAddColumns={onAddColumns}
        onHideColumn={onHideColumn}
        setItemLocation={setItemLocation}
        onChangeSummaryRowStatus={onChangeSummaryRowStatus}
        onExportData={onExportData}
        detailStatus={detailStatus}
        canUpdateProject={canUpdateProject}
        {...props}
      />
      <MenuCreateNew
        setOpenCreateTaskGroup={setOpenCreateTaskGroup}
        setOpenCreate={setOpenCreate}
        setOpenMenuCreate={setOpenMenu}
        anchorEl={openMenu}
        setAnchorEl={setOpenMenu}
      />
      <CreateNewGroupTask
        open={openCreateTaskGroup}
        setOpen={setOpenCreateTaskGroup}
        project_id={projectId}
      />
      {openCreate && (
        <CreateJobModal
          isOpen={openCreate}
          setOpen={setOpenCreate}
          projectId={projectId}
          groupId={selectedGroup}
          project={project}
          fromView={"Table"}
        />
      )}
      <RequestPermission
        open={Boolean(openRequestPermission)}
        projectId={projectId}
        anchorEl={openRequestPermission}
        handleClose={() => setOpenRequestPermission(null)}
      />
      {openMemberSetting && (
        <MemberSetting
          open={openMemberSetting}
          setOpen={setOpenMemberSetting}
          canEdit={canUpdateProject}
          project_id={projectId}
          project={project}
        />
      )}
    </div>
  );
};

const ItemNav = ({ to, id, title, defaultView, mainTask, handleExpand }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isDefaultView = defaultView === id;

  return (
    <li>
      <CusTooltip
        title={<Typography style={{ color: "#fff" }}>Default view</Typography>}
        placement="top"
        disableHoverListener={!isDefaultView}
      >
        <NavLink
          to={to}
          className={classes.link}
          onClick={(e) => {
            if (title === "Chat") {
              dispatch(chooseTask(mainTask));
            }
          }}
        >
          {isDefaultView && (
            <Icon path={mdiCircle} size={0.5} className={classes.defaultIcon} />
          )}
          {title}
        </NavLink>
      </CusTooltip>
    </li>
  );
};

const mapStateToProps = (state) => {
  return {
    status: statusSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdatePinBoardSetting: ({ projectId, status }) =>
      dispatch(updatePinBoardSetting({ projectId, status })),
    doDetailStatus: ({ projectId }) => dispatch(detailStatus({ projectId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderProject);
